// Recovered compiled webpack factory 38708. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { O: () => h });
  let n = (t, e) => (e && "number" == typeof t ? e.transform(t) : t);
  var s = i(96868),
    r = i(40479),
    o = i(21391);
  let a = {
      x: "translateX",
      y: "translateY",
      z: "translateZ",
      transformPerspective: "perspective",
    },
    l = r.U.length;
  function h(t, e, i) {
    let { style: h, vars: u, transformOrigin: d } = t,
      c = !1,
      p = !1;
    for (let t in e) {
      let i = e[t];
      if (r.f.has(t)) {
        c = !0;
        continue;
      }
      if ((0, o.j4)(t)) {
        u[t] = i;
        continue;
      }
      {
        let e = n(i, s.W[t]);
        t.startsWith("origin") ? ((p = !0), (d[t] = e)) : (h[t] = e);
      }
    }
    if (
      (!e.transform &&
        (c || i
          ? (h.transform = (function (t, e, i) {
              let o = "",
                h = !0;
              for (let u = 0; u < l; u++) {
                let l = r.U[u],
                  d = t[l];
                if (void 0 === d) continue;
                let c = !0;
                if ("number" == typeof d) c = d === +!!l.startsWith("scale");
                else {
                  let t = parseFloat(d);
                  c = l.startsWith("scale") ? 1 === t : 0 === t;
                }
                if (!c || i) {
                  let t = n(d, s.W[l]);
                  if (!c) {
                    h = !1;
                    let e = a[l] || l;
                    o += `${e}(${t}) `;
                  }
                  i && (e[l] = t);
                }
              }
              return ((o = o.trim()), i ? (o = i(e, h ? "" : o)) : h && (o = "none"), o);
            })(e, t.transform, i))
          : h.transform && (h.transform = "none")),
      p)
    ) {
      let { originX: t = "50%", originY: e = "50%", originZ: i = 0 } = d;
      h.transformOrigin = `${t} ${e} ${i}`;
    }
  }
}
